module.exports = __webpack_public_path__ + "static/media/pic_bianjing.3a18cc54.png";